export default __webpack_public_path__ + "static/media/pickles_bg.4ff45088.png";